import Utils from "platform/util/Utils";
import {Http, HttpHeader, HttpReject} from "platform/network/http/Http";
import {ServerType} from "platform/enum/ServerType";
import Platform from "platform/Platform";
import {LSKey} from "platform/storage/Storage";
import {TSMap} from "typescript-map";
import {Environment} from "platform/enum/Environment";

const LocalHostPaths: TSMap<ServerType, string> = new TSMap();
LocalHostPaths.set(ServerType.Login, "https://localhost/LoginSite/");
LocalHostPaths.set(ServerType.Compliance, "https://localhost/");
LocalHostPaths.set(ServerType.TradingDemo, "https://localhost/");
LocalHostPaths.set(ServerType.TradingReal, "https://localhost/");

export class Xhr {

    private constructor() {
    }

    public static async sendTo(server: ServerType, request: any = {}, path: string, token: string = null, plain: boolean = false, headers?: HttpHeader[]): Promise<any> {
        const servers: {[key: string]: string} = Platform.config().servers;
        Utils.checkNotNull(servers);
        let serverUrl: string = Platform.config().servers[server];
        if (Environment.isDev()) {
            const stl: string = await Platform.storage().getItem(LSKey.ServerToLocalhost);
            if (stl === "true") {
                serverUrl = LocalHostPaths.get(server);
            }
        }
        Utils.checkNotNull(serverUrl);
        return this.send(serverUrl, request, path, token, plain, headers);
    }

    private static async send(url: string, request: any = {}, path: string, token: string = null, plain: boolean = false, headers: HttpHeader[]): Promise<any> {
        const requestHeaders: HttpHeader[] = headers || [
            {name: "Content-Type", value: "application/json"},
        ];
        if (token) {
            requestHeaders.push({name: "ctoken", value: "sc|" + token});
        }
        const answer: [HttpReject, any] = await Utils.to(Http.post(url + path, plain ? request : JSON.stringify(request), requestHeaders));
        const error: HttpReject = answer[0];
        if (error) {
            return Promise.reject(error);
        } else {
            try {
                return Promise.resolve(JSON.parse(answer[1].trim()));
            } catch (e) {
                return Promise.resolve(null);
            }
        }
    }
}
